<template>
  <div class="selector-container pa-3">
    <ViewBySelector
      v-if="!singleLocation"
    />
    <ScopeSelector
      :singleSelect="singleLocation"
      :onlyActiveLocations="onlyActiveLocations"
    />
  </div>
</template>

<script setup>
import { toRefs, watch, onMounted } from "vue";
import ViewBySelector from "./ViewBySelector.vue";
import ScopeSelector from "./ScopeSelector.vue";
import { useRootStore } from "../../../../stores/root";
import { storeToRefs } from "pinia";

const props = defineProps({
  singleLocation: {
    type: Boolean,
    default: false,
  },
  onlyActiveLocations: {
    type: Boolean,
    default: true,
  },
});

const { singleLocation, onlyActiveLocations } = toRefs(props);
const store = useRootStore();
const { selectedViewBy, selectedScopes } = storeToRefs(store);

watch(singleLocation, () => {
  if (singleLocation.value) {
    selectedViewBy.value = "locations";
  }
});

onMounted(() => {
  if (onlyActiveLocations.value === true) {
    selectedScopes.value = selectedScopes.value.filter(scope => scope.isActive);
  }
});
</script>

<style scoped>
.selector-container {
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>